import { FC } from "react";

import { trackEvent } from "../../../utils/amplitude";

import { FOLLOWING_QUERY_PARAM } from "components/constants";
import { type PresentationBannerColorType } from "components/footer/PresentationBanner";
import { t } from "i18n/i18n";
import { PillButton } from "mds/components/PillButton";
import { useQueryParamsManager } from "utils/routing";

interface StopFollowingButtonProps {
  color: PresentationBannerColorType;
}

export const StopFollowingButton: FC<StopFollowingButtonProps> = ({ color }) => {
  const { deleteQueryParams } = useQueryParamsManager();

  const onClick = () => {
    trackEvent("Presentation - Stop following", { eventCategory: "Button press" });
    deleteQueryParams([FOLLOWING_QUERY_PARAM]);
  };

  return (
    <PillButton
      kind={`banner-${color}`}
      size="s"
      title={t("tooltip.stop_following")}
      onClick={onClick}
    >
      {t("common.stop")}
    </PillButton>
  );
};
